import React from "react";
import { Check } from "lucide-react";

const STEPS = [
  { key: "type", label: "Ad Type" },
  { key: "compose", label: "Composer" },
  { key: "checkout", label: "Checkout" },
  { key: "done", label: "Confirmation" },
];

export default function WizardSteps({ current }) {
  return (
    <div className="flex items-center gap-2 lg:gap-4 mb-10">
      {STEPS.map((s, i) => {
        const idx = STEPS.findIndex((x) => x.key === current);
        const state = i < idx ? "done" : i === idx ? "active" : "todo";
        return (
          <React.Fragment key={s.key}>
            <div className="flex items-center gap-3" data-testid={`step-${s.key}`}>
              <div
                className={`w-9 h-9 rounded-sm flex items-center justify-center text-sm font-mono font-bold border ${
                  state === "done"
                    ? "bg-gold border-gold text-navy-deep"
                    : state === "active"
                    ? "bg-navy text-parchment border-navy"
                    : "bg-white text-slate-400 border-slate-300"
                }`}
              >
                {state === "done" ? <Check size={16} /> : String(i + 1).padStart(2, "0")}
              </div>
              <div className={`hidden sm:block text-sm ${state === "active" ? "text-navy-deep font-semibold" : "text-slate-500"}`}>
                {s.label}
              </div>
            </div>
            {i < STEPS.length - 1 && <div className={`flex-1 h-px ${i < idx ? "bg-gold" : "bg-slate-300"}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
